import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { StoryCard } from "../components/StoryUI";

export default function Category() {
  const { slug } = useParams();
  const [cats, setCats] = useState([]);
  const [stories, setStories] = useState([]);
  const [limit, setLimit] = useState(12);
  const [loading, setLoading] = useState(true);
  const [tag, setTag] = useState(null);

  useEffect(() => {
    setLoading(true);
    (async () => {
      const [c, s] = await Promise.all([
        api.get("/categories").then(r => r.data),
        api.get("/stories", { params: { category: slug, limit: 50 } }).then(r => r.data),
      ]);
      setCats(c);
      setStories(s);
      setLoading(false);
    })();
  }, [slug]);

  const cat = cats.find(c => c.slug === slug);
  const tags = [...new Set(stories.flatMap(s => s.tags || []))].slice(0, 10);
  const filtered = tag ? stories.filter(s => s.tags?.includes(tag)) : stories;

  return (
    <div data-testid={`category-page-${slug}`}>
      <div className="relative py-10 sm:py-16 overflow-hidden" style={{ backgroundColor: cat?.color || "#F42A41" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <Link to="/" className="text-xs font-bold uppercase tracking-widest text-white/70 hover:text-white">← Back</Link>
          <h1 className="font-display font-extrabold text-4xl sm:text-6xl text-white mt-3">{cat?.name || slug}</h1>
          <p className="text-white/80 mt-2 text-sm">All {cat?.name || slug} stories, short and sharp.</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        {tags.length > 0 && (
          <div className="flex gap-2 flex-wrap mb-6" data-testid="tag-filter">
            <button onClick={() => setTag(null)} className={`h-8 px-3 rounded-full text-xs font-bold border ${!tag ? "bg-foreground text-background border-foreground" : "border-border"}`}>All</button>
            {tags.map(t => (
              <button key={t} onClick={() => setTag(t)} data-testid={`tag-${t}`}
                className={`h-8 px-3 rounded-full text-xs font-bold border ${tag === t ? "bg-foreground text-background border-foreground" : "border-border"}`}>#{t}</button>
            ))}
          </div>
        )}
        {loading ? <div className="py-10 text-center text-muted-foreground">Loading…</div> : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {filtered.slice(0, limit).map(s => <StoryCard key={s.id} story={s} cats={cats} />)}
            </div>
            {filtered.length > limit && (
              <div className="text-center mt-8">
                <button onClick={() => setLimit(l => l + 12)} className="h-11 px-6 rounded-full bg-foreground text-background font-bold" data-testid="load-more">Load more</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
